import classNames from "classnames";
import { HTMLProps, useRef } from "react";
import styles from "./style.module.scss";

interface InputProps extends HTMLProps<HTMLInputElement> {}

const CustomDate = ({
  value,
  placeholder,
  onChange,
  defaultValue,
  min,
  max,
}: Partial<InputProps>) => {
  const dateRef: any = useRef(null);
  return (
    <div className={classNames("relative w-full")}>
      <div className={classNames(styles.dateInputToggle)}>
        <input
          defaultValue={defaultValue}
          type="date"
          id="dateInput"
          name="dateInput"
          placeholder={placeholder}
          className={classNames(styles.dateInputStyle)}
          value={value}
          ref={dateRef}
          onChange={onChange}
          min={min}
          max={max}
        />
      </div>
      <input
        defaultValue={defaultValue}
        type={"text"}
        placeholder={placeholder}
        className={classNames(styles.inputStyle, styles.dateInputTextStyle)}
        value={value}
        onClick={() => {
          dateRef.current.showPicker();
        }}
        role="button"
      />
    </div>
  );
};

export default CustomDate;
